module.exports = __webpack_public_path__ + "static/media/CabinetCorner_After.ad0baf33.jpg";